import { render, staticRenderFns } from "./send-mail.vue?vue&type=template&id=515b36e3&scoped=true"
import script from "./send-mail.vue?vue&type=script&lang=ts"
export * from "./send-mail.vue?vue&type=script&lang=ts"
import style0 from "./send-mail.vue?vue&type=style&index=0&id=515b36e3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515b36e3",
  null
  
)

export default component.exports